module.exports = __webpack_public_path__ + "img/popularity-checked-ar.e532e727.png";